// ANGULAR
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

// APP
import { WHAgmCoreLocationFormRoutingModule } from './w-h-agm-core-location-form-routing.module';
import { WHAgmCoreLocationFormComponent } from './w-h-agm-core-location-form.component';

// MODULE
import { AppSharedModule } from 'src/app/app-shared/app-shared.module';
import { WHAgmCoreSearchUtilModule } from '../w-h-agm-core-search-util/w-h-agm-core-search-util.module';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  declarations: [
    WHAgmCoreLocationFormComponent
  ],
  exports: [
    WHAgmCoreLocationFormComponent
  ],
  imports: [
    ReactiveFormsModule,
    AppSharedModule,
    WHAgmCoreSearchUtilModule,
    WHAgmCoreLocationFormRoutingModule,
    GoogleMapsModule
  ]
})
export class WHAgmCoreLocationFormModule { }
